import { createReducer } from 'typesafe-actions';
import { PaperlessAction } from '@store/actions';
import { fetchPaperlessAsync, shownPaperlessSuccess } from '@store/actions/paperless.action';

export const paperLess: any = {};

export const paperlessReducer = createReducer<any, PaperlessAction>(paperLess)
    .handleAction(fetchPaperlessAsync.success, (state, action) => ({
        ...state,
        ...action.payload
    }))
    .handleAction(fetchPaperlessAsync.failure, (state, action) => ({
        ...state,
        ...action.payload
    }))
    .handleAction(shownPaperlessSuccess, (state, action) => ({
        ...state,
        shownPaperlessSnack: action.payload
    }));
